var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.745 2.257a4.304 4.304 0 0 1 0 6.08 4.266 4.266 0 0 1-3.652 1.216.735.735 0 0 0-.19 0A2.21 2.21 0 0 0 23.536 11c-.19.528-.181 1.13.074 1.68a8.26 8.26 0 0 1-1.651 9.277 8.26 8.26 0 0 1-9.279 1.65 2.208 2.208 0 0 0-1.7-.066 2.21 2.21 0 0 0-1.44 2.235.738.738 0 0 0 0 .22 4.313 4.313 0 0 1-1.2 3.748 4.305 4.305 0 0 1-6.08 0A4.272 4.272 0 0 1 1 26.703a4.27 4.27 0 0 1 1.26-3.04c.965-.966 2.296-1.408 3.719-1.213.142.029.288.049.436.049a2.21 2.21 0 0 0 2.07-1.43 2.208 2.208 0 0 0-.06-1.719 8.26 8.26 0 0 1 1.65-9.275 8.26 8.26 0 0 1 9.278-1.65 2.208 2.208 0 0 0 1.696.068 2.21 2.21 0 0 0 1.246-1.148c.2-.43.247-.891.168-1.339a4.312 4.312 0 0 1 1.2-3.749 4.303 4.303 0 0 1 6.08 0zM12.68 12.68a4.763 4.763 0 1 0 6.737 6.735 4.763 4.763 0 0 0-6.736-6.736z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHnt);
export default __webpack_public_path__ + "static/media/HNT.f4f56b830574e617b81700e4fb5bb33c.svg";
export { ForwardRef as ReactComponent };